import { Feature, ListItem } from '@tencent/workbench';
import BaseGridFeature from '@framework/workbench/common/feature/base-grid-feature';
import { config } from './config';
import { isNoteModel } from '@src/slide/domain/ui-model/elements/element-judge';

@Feature()
export class RowSpaceFeature extends BaseGridFeature {
    id = config.id;
    config = config;

    public getSelectedValue() {
        const values = this.getMenuManager()?.toolbarMenu().values;
        return String(values?.[config.id]);
    }

    /**
     * workbench的select列表id不支持数字，需要转为字符串
     */
    public getSelectList() {
        const { dropdown } = this.config;
        const { data = [] } = dropdown;
        const res: ListItem[] = data.map(item => ({
            id: String(item.id),
            content: item.content,
        }));
        // 备注区域需要禁用段落属性面板的入口
        if (isNoteModel(this.getSelectionService().getSelectedModel())) {
            const customRowspaceEntryItem = res.find(item => item.id === 'custom');
            if (customRowspaceEntryItem) {
                customRowspaceEntryItem.disabled = true;
            }
        }
        return res;
    }

    public onChange(value, isDrawer?: boolean) {
        if (value === 'custom') {
            this.getAppService().editableServiceLayer?.paragraphManager.showParagraph();
        } else {
            isDrawer ? this.drawerCallback(value) : this.callback(value);
        }
    }
}
